import { useLocation } from 'react-router-dom';

import { isErrorOrBlockedRoute } from 'modules/Notifications/inviteNotificationRoutes';
import useSingleTabContext from 'modules/SingleTabGuard/useSingleTabContext';
import { useIsRoomRoute } from 'routes/hooks/useIsRoomRoute';

/**
 * Invite notifications are deferred (queued, never surfaced) while the user is outside the app
 * shell: duplicate tabs (#7972), inside a call (`/rooms/*`, `/meeting/*`), or on an error/blocked
 * route. They flush when this returns false again — i.e. when the user navigates back to a shell
 * route (`/messenger`, `/meetings`, `/calendar`, ...) on the main tab.
 */
const useDeferInviteNotifications = (): boolean => {
  const { isMainTab } = useSingleTabContext();
  const { pathname } = useLocation();
  const isRoomRoute = useIsRoomRoute();

  if (!isMainTab) return true;
  return isRoomRoute || isErrorOrBlockedRoute(pathname);
};

export default useDeferInviteNotifications;
